import React, { useState } from 'react';
import classNames from 'classnames';
import ModalAction from '@/components/ModalAction';
import LoaderIcon from '@/images/icons/Loader';
import { Input } from '@/components/Form/Input';
import DropdownSelect from '@/components/DropdownSelect';
import { Textarea } from '@/components/Form/Textarea';

const isUrl = (str: string) => {
	return /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/.test(str);
};

const PrivacyModal = ({ modalOpen, setModalOpen, modalError, privacyData, submitCallback, isLoading, onFieldChange }: any) => {
	const [privacyType, setPrivacyType] = useState(isUrl(privacyData) ? 'link-privacy-policy' : 'text-privacy-policy');
	const [fieldValue, setFieldValue] = useState(privacyData);

	const onClearModal = () => {
		setModalOpen(false);
	};

	const onSubmit = async () => {
		submitCallback({ linkPrivacy: fieldValue });
	};

	const options = [
		{ value: 'text-privacy-policy', content: 'Text of Privacy Policy' },
		{ value: 'link-privacy-policy', content: 'Link on Privacy Policy' },
	];
	const orderedOptions = options.sort((a, b) => (a.value === privacyType ? -1 : b.value === privacyType ? 1 : 0));

	return (
		<ModalAction
			id="privacy-modal"
			modalOpen={modalOpen}
			setModalOpen={setModalOpen}
			onModalClose={() => onClearModal()}
			size={undefined}
		>
			<div className="h2 mb-6 md:mb-8">
				{fieldValue ? 'Edit' : 'Add'} Privacy Policy
			</div>
			<DropdownSelect
				options={orderedOptions}
				selectSet={setPrivacyType}
				className={`mb-2 md:mb-3 transition-all`}
			/>
			{privacyType === 'text-privacy-policy' && (
				<Textarea
					className=""
					name="privacy-policy"
					onChange={(e) => onFieldChange('linkPrivacy', e.target.value)}
					rows={16}
					defaultValue={!isUrl(privacyData) ? privacyData : ''}
				>
					Text of Privacy Policy
				</Textarea>
			)}
			{privacyType === 'link-privacy-policy' && (
				<Input
					className="h-11"
					type="text"
					name="privacy-policy"
					onChange={(e) => onFieldChange('linkPrivacy', e.target.value)}
					defaultValue={isUrl(privacyData) ? privacyData : ''}
				>
					Paste link on Privacy Policy
				</Input>
			)}
			{modalError && (
				<div className="text-sm text-red-orange mt-2 font-medium">{modalError}</div>
			)}
			<button className={classNames(
				`btn-primary w-full mt-8`,
				!isLoading && 'hidden',
			)}>
				<div className="flex items-center justify-center py-1 pointer-events-none">
					<LoaderIcon className="animate-rotation w-6 h-6 text-white" />
				</div>
			</button>
			<div className={isLoading ? "hidden" : ""}>
				<button className="btn-primary w-full mt-8" onClick={() => onSubmit()}>
					<span className="pointer-events-none">{privacyData ? 'Save' : 'Add'}</span>
				</button>
				<button className="btn-primary-inverted w-full mt-4" onClick={() => onClearModal()}>
					<span className="pointer-events-none">Undo</span>
				</button>
			</div>
		</ModalAction>
	);
};

export default PrivacyModal;
